module.exports = __webpack_public_path__ + "static/img/image4.9770a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image4.jpg
// module id = T6ud
// module chunks = 1